import styled from 'styled-components';

const Wrapper = styled.div<{ $type?: string; }>`
  display: inline-block;
  align-items: center;
  background-color: ${(props) => props.theme.colors.outline};
  width: ${(props) => {
    switch (props.$type) {
      case 'single': return 'calc(100% - 10px)';
      case 'double': return 'calc(50% - 10px)';
      case 'quad': return 'calc(25% - 10px)';
      case 'triple':
      default: return 'calc(33.3% - 10px)';
    }
  }};
  border-radius: 12px;
  margin: 5px;
  height: 60px;
  padding: 10px;
  cursor: default;

  .dot {
    height: 8px;
    width: 8px;
    background-color: #bbb;
    border-radius: 50%;
    margin: 0 auto;

    &.red {
      background-color: ${(props) => props.theme.colors.red};
    }

    &.yellow {
      background-color: ${(props) => props.theme.colors.main_cta};
    }

    &.green {
      background-color: ${(props) => props.theme.colors.green};
    }

    &.orange {
      background-color: ${(props) => props.theme.colors.orange};
    }

    &.salmon {
      background-color: ${(props) => props.theme.colors.salmon};
    }

    &.light-yellow {
      background-color: ${(props) => props.theme.colors.light_yellow};
    }
  }

  .count {
    padding: 4px 0;
    font-family: 'ManropeExtraBold';
    font-size: 13px;
    text-align: center;
    color: ${(props) => props.theme.colors.text};
  }

  .label {
    font-size: 13px;
    font-size: ${(props) => `${props.$type === 'quad' ? 11 : 13}px`};
    text-align: center;
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
